import React, { useMemo } from 'react';

import { getValueByPropPath } from '../../../../utils/objectHelpers';
import { pluralizeName } from '../../../Order/Renter/Create/TicketOrderItem';

export const SidePanelRvs = ({ children, order }) => {
  const { reservation: orderReservation = {}, quantity } = order;
  const { rvProduct: orderReservationRvProduct = {} } = orderReservation;
  const rvSpots = orderReservation.rvSpots || [];
  const names = useMemo(() => rvSpots.map(rvSpot => rvSpot.name).join(', '), [JSON.stringify(rvSpots)]);
  const name = getValueByPropPath(orderReservationRvProduct, 'name', 'Unassigned');
  const lotName = getValueByPropPath(orderReservationRvProduct, 'rvLot.name', 'Unassigned');
  const numberOfSpots = `${quantity} ${pluralizeName('spot', quantity)}`;
  const columns = [
    {
      title: 'LOCATION',
      text: name || lotName
    },
    { title: 'SPOTS', text: names || numberOfSpots }
  ];
  return <>{children(columns)}</>;
};
